<template>
    <v-card color="#1F7087" dark>
        <div class="d-flex flex-no-wrap justify-space-between">
            <div>
                <v-card-title class="text-h5">
                    <h2>{{ title }}</h2>
                    <v-icon>mdi-arrow-bottom-left-thick</v-icon>
                </v-card-title>
                <v-card-subtitle> </v-card-subtitle>
                <v-card-subtitle>
                    <h3>本網站大略依無障礙網頁設計原則而建置，網站的主要內容區塊如下：</h3>
                </v-card-subtitle>
                <v-card-subtitle><p>1.上方功能區。2.中央內容區，為本頁主要內容。3.下方功能區。</p></v-card-subtitle>
                <v-card-subtitle>
                    <h3>本網站的快速鍵 (Accesskey) 設定如下：</h3>
                </v-card-subtitle>
                <v-card-subtitle>
                    <p>
                        <span class="key_hlight">Alt + U</span>
                        ：上方功能區，包括回首頁、網站地圖等。
                    </p>
                </v-card-subtitle>
                <v-card-subtitle
                    ><p>
                        <span class="key_hlight">
                            Alt + C
                        </span>
                        ：中央內容區，為本頁主要內容。
                    </p>
                </v-card-subtitle>
                <v-card-subtitle
                    ><p>
                        <span class="key_hlight">
                            Alt + B
                        </span>
                        ：下方功能區，包括網站資料開放宣告、版權宣告說明等。
                    </p>
                </v-card-subtitle>
                <v-card-subtitle><h3>列表查詢</h3></v-card-subtitle>
                <v-card-subtitle>
                    <ul class="site-map-ul">
                        <li>
                            <a href="/accessibleWeb" title="移至列表查詢|首頁">首頁</a>
                        </li>
                        <li>
                            <a href="/#/cmsMsg" title="移至列表查詢|CMS資訊">CMS資訊</a>
                        </li>
                        <li>
                            <a href="/#/ubikeMsg" title="移至列表查詢|Youbike資訊">Youbike資訊</a>
                        </li>
                        <li>
                            <a href="/#/busMsg" title="移至列表查詢|公車資訊">公車資訊</a>
                        </li>
                        <li>
                            <a href="/#/parkingMsg" title="移至列表查詢|Youbike資訊">停車場資訊</a>
                        </li>
                        <li>
                            <a href="/#/announceMsg" title="移至列表查詢|即時公告">即時公告</a>
                        </li>
                    </ul>
                </v-card-subtitle>
            </div>

            <v-img alt="新北即時交通網" :src="require('../assets/about.png')" max-width="350" class="hidden-sm-and-down"></v-img>
        </div>
    </v-card>
</template>
<script>
export default {
    name: 'SiteMapPage', //網路地圖 頁面
    data() {
        return {
            title: '網路地圖',
            breadcrumbs: [
                {
                    text: ':::',
                    disabled: false,
                    href: '#main',
                    title: '中央內容區，為本頁主要內容。',
                },
                {
                    text: 'home',
                    disabled: false,
                    href: '#/',
                    title: '首頁',
                },
                {
                    text: '網路地圖',
                    disabled: true,
                },
            ],
        };
    },
    created() {
        console.log('AboutMe start');
        this.$store.commit('setBreadcrumbs', this.breadcrumbs);
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                document.title = to.meta.title || '新北即時交通資訊網';
            },
        },
    },
    mounted() {},
};
</script>
<style scoped>
.key_hlight {
    background: #128534;
    padding: 5px;
    font-size: 1.2em;
}

.site-map-ul {
    display: flex;
    flex-wrap: wrap;
}

.site-map-ul li {
    padding: 10px 25px;
    border-radius: 5px;
    border: 1px solid #00bcd2;
    margin: 5px 0;
    line-height: 2.2em;
    text-align: center;
    margin: 5px;
}

.site-map-ul li a {
    color: #fff;
}

ul li {
    list-style-type: none;
}
</style>
